export function clienteEliminarModal(item, entity) {
  return {
    id: item.id,
    title: "Por favor, confirme que desea eliminar a este Cliente",
    subtitle:
      "¡CUIDADO! Eliminar a este cliente eliminará también todos sus pedidos. Esta acción no se puede deshacer.",
    texts: [
      {
        text: "Código de cliente",
        value: item.client_code,
      },
      {
        text: "Nombre",
        value: item.name,
      },
      {
        text: "Razón Social",
        value: item.business_name,
      },
      {
        text: "Pedidos",
        value:
          "¡CUIDADO! Eliminar a este cliente eliminará sus " +
          item.orders.length +
          " pedidos.",
      },
    ],
    buttons: [
      {
        text: "Confirmar",
        action: "delete",
        classes: "unsafe",
        entity: entity,
        actionType: "mutation",
      },
      {
        text: "Cancelar",
        action: "closeModal",
        classes: "safe",
        entity: entity,
      },
    ],
  };
}
